var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Block',{attrs:{"data":_vm.blockViewModel,"blockHeadingClass":_vm.large ? 'medium-block-heading' : 'small-block-heading'}})}
var staticRenderFns = []

export { render, staticRenderFns }